export const basePath = '/qa/scoring'

export const routes = {
  root: basePath,
  main: (uid?: string) => `${basePath}?score=${uid}`,
  createScore: (): string => `${basePath}/create`,
  editScore: (uid: string): string => `${basePath}/edit/${uid}`,
}
